import { aboutFeatures, contactInfo } from "@/mocks/homeData";

export default function AboutSection() {
  return (
    <section id="garage" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <span className="text-sm font-semibold tracking-wider text-primary-500 uppercase mb-2 block">
              À propos de nous
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-6 font-heading tracking-wide">
              Un garage automobile de proximité au Tampon
            </h2>
            <div className="space-y-4 text-white/80 leading-relaxed">
              <p>
                Chez Mobicar Pro, chaque intervention commence par l'écoute du
                conducteur et l'analyse du véhicule. L'objectif est de comprendre
                l'origine du problème, de proposer une intervention adaptée et
                d'expliquer clairement les travaux à réaliser.
              </p>
              <p>
                Situé au Tampon, à La Réunion, Mobicar Pro accueille les
                véhicules de toutes marques pour l'entretien courant, le
                diagnostic et la réparation automobile. La priorité est de
                prendre le temps nécessaire pour identifier les besoins réels du
                véhicule et proposer une solution adaptée.
              </p>
              <p>
                Que ce soit pour un bruit inhabituel, un voyant allumé ou un
                entretien régulier, l'équipe vous reçoit avec le sérieux et la
                proximité d'un garage local. Les explications sont données de
                manière accessible, même si vous ne connaissez pas la mécanique.
              </p>
            </div>

            <div className="mt-8 flex flex-wrap gap-4">
              {aboutFeatures.map((feature) => (
                <div
                  key={feature}
                  className="flex items-center gap-2 text-sm text-white/80"
                >
                  <i className="ri-check-line text-primary-500 w-5 h-5 flex items-center justify-center" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/3] rounded-lg overflow-hidden bg-secondary-200">
              <img
                alt="Intérieur du garage Mobicar Pro au Tampon"
                className="w-full h-full object-cover"
                loading="lazy"
                width="800"
                height="600"
                src="/assets/images/about.webp"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-primary-500 text-white px-4 py-3 rounded-md">
              <p className="text-xs font-semibold uppercase tracking-wider">
                Mobicar Pro
              </p>
              <p className="text-sm font-bold">Le Tampon, La Réunion</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}